import { html, css } from 'lit-element';
import { FormElement } from './form-element-base';
import { HeaderStyles } from '../styles/header-styles';
import '@trumedianetworks/tmn-core-components/src/tmn-input';
import '@trumedianetworks/tmn-core-components/src/tmn-checkbox';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-form-group';
import '@trumedianetworks/tmn-core-components/src/tmn-select';
import './shared-auth-lookup';

class FormElementAuthContext extends FormElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            css`
                .content {
                    margin: 0px 10px 6px;
                }
                tmn-select {
                    font-size: 14px;
                    min-width: 155px;
                }
                a.auth-site {
                    text-transform: capitalize;
                    user-select: none;
                    text-decoration: none;
                    color: var(--routed-link-color);
                }
                a.auth-site:hover {
                    text-decoration: underline;
                }
                .shared-wrapper {
                    min-height: 75px;
                    width: 200px;
                    padding: 10px;
                    background-color: #fafafa;
                    border: 1px solid rgba(0, 0, 0, 0.1);
                    border-top: 0;
                }
                .auth-radio {
                    margin-bottom: 8px;
                }
                .auth-radio tmn-radio {
                    padding-left: 10px;
                    min-width: 200px;
                    border: 1px solid rgba(0, 0, 0, 0.1);
                }
                .auth-radio tmn-radio:first-child {
                    border-bottom: 0;
                }
            `,
            super.styles,
            HeaderStyles.styles,
        ];
    }

    static get properties() {
        return {
            searchValue: {
                type: String,
            },
            multiple: {
                type: Boolean,
            },
            selectedQueryData: {
                type: Object,
            },
            selectedData: {
                type: Array,
            },
            selectedEntity: {
                type: Object,
            },
        };
    }

    render() {
        if (this.isViewMode()) {
            return html` <div class="content">${this.renderAuthSiteLink()}</div>`;
        }
        return html` <div class="content">${this.renderAuthGroup()}</div> `;
    }

    renderAuthGroup() {
        const { value, validationError = {} } = this;
        const { authSiteName, useIntrinsicAuthentication, sharedAuthApiKey } = value;
        const sharedAuthSiteName = sharedAuthApiKey ? authSiteName : null;
        const apiKeyError = validationError?.sharedAuthApiKey;
        return html`<tmn-radio-group
                class="auth-radio"
                @tmn-radio-group-value-changed=${this.hanldeAuthModeChanged}>
                <tmn-radio color="primary" value="intrinsic" .checked=${useIntrinsicAuthentication}
                    >Intrinsic</tmn-radio
                >
                <tmn-radio color="primary" value="shared" .checked=${!useIntrinsicAuthentication}
                    >Shared</tmn-radio
                >
                ${useIntrinsicAuthentication
                    ? null
                    : html`<div class="shared-wrapper">
                          <shared-auth-lookup
                              .sharedAuthApiKey=${sharedAuthApiKey}
                              .authSiteName=${sharedAuthSiteName}
                              @shared-auth-changed=${this.handleApiKeyChanged}>
                          </shared-auth-lookup>
                      </div>`}
            </tmn-radio-group>
            ${this.renderCustomError(apiKeyError)} `;
    }

    hanldeAuthModeChanged(e) {
        const { path, value } = this;

        const newValue = {
            ...value,
            useIntrinsicAuthentication: e.detail.value === 'intrinsic',
        };
        this.actions.setStagedEditByPath(path, newValue);
    }

    renderAuthSiteLink() {
        const { value } = this;
        const { authSiteName, useIntrinsicAuthentication } = value;
        if (this.isAddNewMode()) {
            return null;
        }
        const typeDetail = useIntrinsicAuthentication ? 'Intrinsic' : 'Shared';
        return html` <tmn-form-group>
            <label>Auth Site:</label>
            <span
                ><a class="auth-site" href="/${authSiteName}/users/" target="_blank"
                    >${authSiteName}</a
                >
                (${typeDetail})
            </span>
        </tmn-form-group>`;
    }

    handleApiKeyChanged({ detail }) {
        // note auth name is correct here so we use it for display, but only the sharedAuthApiKey is actually used to save
        const { sharedAuthApiKey, authSiteName } = detail;
        const { path, value } = this;
        const newValue = {
            ...value,
            sharedAuthApiKey,
            authSiteName,
        };
        this.actions.setStagedEditByPath(path, newValue);
    }

    handleEmailDomainChanged({ detail }) {
        const emailAccountDomain = detail.value;
        const { path, value } = this;
        const newValue = {
            ...value,
            emailAccountDomain,
        };
        this.actions.setStagedEditByPath(path, newValue);
    }
}

window.customElements.define('form-element-auth-context', FormElementAuthContext);
